<modal-form-container
  title="Add to organizations"
  className="md:w-[720px] lg:w-[760px]"
  [showModal]="showModal"
  (closeModalEvent)="closeModal()"
>
  @if (showModal) {
    <div class="gm">
      <p class="gm__lead">
        The <strong>{{ rowLabel }}</strong> you picked join these organizations when the import is saved.
      </p>

      <bk-group-picker kind="organization" [selected]="selectedOrganizations" (selectedChange)="onPick($event)" />

      <div class="gm__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          [disabled]="!selectedOrganizations.length"
          (click)="handleSubmit()"
        >
          {{ submitLabel }}
        </button>
      </div>
    </div>
  }
</modal-form-container>
